import { CoreModel } from '../core/core.model';
import { IconModel } from '../icon/icon.model';
export class SelectModel extends CoreModel {
/**
 * <p>Placeholder text</p>
 */
placeholder?: string;
/**
 * <p>Not changable static placeholder text</p>
 */
staticPlaceholder?: string;
/**
 * <p>Options source type</p>
 */
optionsSource?: string;
/**
 * <p>Array with options</p>
 */
options?: any[];
/**
 * <p>Select component must have some selected item and it is value of item property described in <b>itemValue</b></p>
 */
selected?: any;
/**
 * <p>Show/Hide filter</p>
 */
showFilter?: boolean;
/**
 * <p>Show/Hide icon</p>
 */
showIcon?: boolean;
/**
 * <p>Icon</p>
 */
iconProperty?: IconModel;
/**
 * <p>If main icon can be changed with selected option icon</p>
 */
iconChangeable?: boolean;
/**
 * <p>Required</p>
 */
required?: boolean;
/**
 * <p>Options multipleselection</p>
 */
multiple?: boolean;
/**
 * <p>If select dropdown must be under it placeholder</p>
 */
dropdownUnder?: boolean;
/**
 * <p>Option property name to be used as option value</p>
 */
optionValueField?: string;
/**
 * <p>Option property name to be used as select text when option is selected and as option text if item property is not specified</p>
 */
optionLabelField?: string;
/**
 * <p>Option property name to be used as option item</p>
 */
optionItemField?: string;
/**
 * <p>Option property name to be used as option icon</p>
 */
optionIconField?: string;
/**
 * @hidden 
 * It is icon constructor, which take values from Select Component and create Select Model object.
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function SelectModel_tsickle_Closure_declarations() {
/**
 * <p>Placeholder text</p>
 * @type {?}
 */
SelectModel.prototype.placeholder;
/**
 * <p>Not changable static placeholder text</p>
 * @type {?}
 */
SelectModel.prototype.staticPlaceholder;
/**
 * <p>Options source type</p>
 * @type {?}
 */
SelectModel.prototype.optionsSource;
/**
 * <p>Array with options</p>
 * @type {?}
 */
SelectModel.prototype.options;
/**
 * <p>Select component must have some selected item and it is value of item property described in <b>itemValue</b></p>
 * @type {?}
 */
SelectModel.prototype.selected;
/**
 * <p>Show/Hide filter</p>
 * @type {?}
 */
SelectModel.prototype.showFilter;
/**
 * <p>Show/Hide icon</p>
 * @type {?}
 */
SelectModel.prototype.showIcon;
/**
 * <p>Icon</p>
 * @type {?}
 */
SelectModel.prototype.iconProperty;
/**
 * <p>If main icon can be changed with selected option icon</p>
 * @type {?}
 */
SelectModel.prototype.iconChangeable;
/**
 * <p>Required</p>
 * @type {?}
 */
SelectModel.prototype.required;
/**
 * <p>Options multipleselection</p>
 * @type {?}
 */
SelectModel.prototype.multiple;
/**
 * <p>If select dropdown must be under it placeholder</p>
 * @type {?}
 */
SelectModel.prototype.dropdownUnder;
/**
 * <p>Option property name to be used as option value</p>
 * @type {?}
 */
SelectModel.prototype.optionValueField;
/**
 * <p>Option property name to be used as select text when option is selected and as option text if item property is not specified</p>
 * @type {?}
 */
SelectModel.prototype.optionLabelField;
/**
 * <p>Option property name to be used as option item</p>
 * @type {?}
 */
SelectModel.prototype.optionItemField;
/**
 * <p>Option property name to be used as option icon</p>
 * @type {?}
 */
SelectModel.prototype.optionIconField;
}

